module.exports = __webpack_public_path__ + "img/egl.b4798e5d.png";